import React from 'react';
export var themes = {
  dark: {
    sidebar: 'dark-sidebar'
  },
  light: {
    sidebar: 'light-sidebar'
  }
};
var ThemeContext = /*#__PURE__*/React.createContext(themes.dark);
export default ThemeContext;